import { ApolloQueryResult } from 'apollo-client'
import { Button, Icon, Tooltip } from 'bold-ui'
import { useAlert } from 'components/alert'
import { confirm } from 'components/modals/confirm'
import { useExcluirGrupoExameMutation } from 'graphql/hooks.generated'
import { GrupoExameTableQuery } from 'graphql/types.generated'
import React, { SyntheticEvent } from 'react'

import { GrupoExameRowItem } from './GrupoExameTable'

interface GrupoExameExcludeActionProps {
  grupoExame: GrupoExameRowItem
  refetch(): Promise<ApolloQueryResult<GrupoExameTableQuery>>
}

export function GrupoExameExcludeAction(props: GrupoExameExcludeActionProps) {
  const {
    refetch,
    grupoExame: { id },
  } = props
  const [excluirGrupoExame] = useExcluirGrupoExameMutation()
  const alert = useAlert()
  const onClick = (e: SyntheticEvent) => {
    e.stopPropagation()
    confirm({
      title: 'Deseja excluir o grupo de exames?',
      type: 'danger',
      confirmLabel: 'Excluir',
      onConfirm: () =>
        excluirGrupoExame({ variables: { id: id.toString() } }).then(() => {
          alert('success', 'Grupo de exames excluído com sucesso.')
          refetch()
        }),
    })()
  }

  return (
    <Tooltip text='Excluir'>
      <Button size='small' skin='ghost' onClick={onClick}>
        <Icon icon='trashOutline' />
      </Button>
    </Tooltip>
  )
}
